import React from 'react';
import { Box, Typography } from '@mui/material';
import i18next from 'i18next';
import { bookingModeSelector } from 'helper/filter';
import { EBookingMode } from 'types';

interface ContactPersonTabsWrapperProps {
  responsibleUser?: { name: string; email: string } | null;
  children: React.ReactNode;
}

export default function ContactPersonTabsWrapper({ responsibleUser, children }: ContactPersonTabsWrapperProps) {
  const bookingMode = bookingModeSelector();

  if (bookingMode === EBookingMode.SEM) {
    return <>{children}</>;
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          top: 0,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          zIndex: 1,
          pr: 1,
        }}
      >
        <Typography variant="body2" component="span" sx={{ color: 'text.secondary' }}>
          {i18next.t('offer-seminargo-contact')}:{' '}
          {responsibleUser ? (
            <Box
              component="a"
              href={`mailto:${responsibleUser.email}`}
              sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              {responsibleUser.name}
            </Box>
          ) : (
            <Box
              component="a"
              href="mailto:office@seminargo.com"
              sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              {i18next.t('offer-seminargo-contact-office')}
            </Box>
          )}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}
